import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../utils/baseQueryWithAuth';

const mdmsUrl = process.env.REACT_APP_MDMS_URL;
// Define a service using a base URL and expected endpoints
export const featuresAccessPanelApi = createApi({
  reducerPath: 'featuresAccessPanelApi',
  baseQuery: baseQueryWithReauth,
  keepUnusedDataFor: 300,
  endpoints: (builder) => ({
    getAllFeatures: builder.query({
      query: (params) => ({
        url: `${mdmsUrl}/prepaid-engine/feature_access_control/${params}`
      }),
      providesTags: ['getAllFeatures']
    }),
    updateFeaturesBulk: builder.mutation({
      query: (data) => ({
        url: `${mdmsUrl}/prepaid-engine/feature_access_control/many/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['getAllFeatures']
    }),
    featuresEditDropdowns: builder.query({
      query: () => ({
        url: `${mdmsUrl}/prepaid-engine/mdms_api/prepaid_configuration/dropdowns`
      })
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllFeaturesQuery,
  useUpdateFeaturesBulkMutation,
  useFeaturesEditDropdownsQuery
} = featuresAccessPanelApi;
